<template>
<div class="chapter">
<div class="inner_page">
<h1>ACKNOWLEDGMENTS</h1>
<div class="image" id="image2">
<p class="center"><img alt="cutting board" src="images/image-1.jpg"/></p>
</div>
<p class="noindent">This book is for my father and mother, Bruce and Pat LeFavour, and my sister, Nicole. I get so nostalgic about these three when I write about food. Maybe that’s because it was with them — as a family we revolved around eating purposefully long before it was fashionable to do so—that I came to recognize the power of cooking, eating, and sitting down to meal after meal together. This recognition would be meaningless were it not for the family my husband, Dwight Garner, and I made for ourselves and our two children, Penn and Hattie. I have them to thank for many months of taste-testing the recipes in this book. They were always cheerful—even when, I suspect, all they really wanted for a change was a big fat steak instead of more poulet.</p>
<p class="spacer">Many other people have applied their time, intelligence, and talent to the making of this book. Before anyone else, I am indebted to my estimable agent, David McCormick, for his unwavering faith in Poulet. David got the book long before it was a reality, and it was he who found its perfect match in Bill LeBlond at Chronicle Books. I thank Bill for having the vision to turn my manuscript into such a beautiful book. I’d also like to thank Sarah Billingsley for so gracefully seeing the manuscript through from its inception, and Carrie Bradley Neves for her meticulous editing. I’m also grateful for Sara Schneider’s outstanding design and France Ruffenach’s gorgeous photography.</p>
<p class="spacer">Finally, thank you to my friends and family. There’s nothing I’d rather do than sit down at the table for a meal with you and drink wine, smear butter on crusty bread, and talk, argue, and gesture until the carcass of a big roast chicken in the middle of the table is picked clean. Vegetarians not excepted, you know who you are.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003-acknowledgments.vue?c9fe58fc